import Vuebar from 'vuebar'

Vue.use(Vuebar)
